module.exports = __webpack_public_path__ + "roboto-medium-webfont.b54bf9e820d24df67abf.ttf";


//////////////////
// WEBPACK FOOTER
// /home/vatzcar/public_html/BEX-VoucherAdmin/src/assets/fonts/roboto-medium-webfont.ttf
// module id = ../../../../../src/assets/fonts/roboto-medium-webfont.ttf
// module chunks = styles